import "./WhyChooseUs.css";
import { FaCheckCircle } from "react-icons/fa";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import image from '../Pages/images/qua.png'
gsap.registerPlugin(ScrollTrigger);

const WhyChooseUs = () => {
  const sectionRef = useRef(null);
  const reasonsRef = useRef([]);

  useEffect(() => {
    gsap.fromTo(
      sectionRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out", scrollTrigger: { trigger: sectionRef.current, start: "top 80%" } }
    );

    reasonsRef.current.forEach((reason, index) => {
      gsap.fromTo(
        reason,
        { opacity: 0, x: -50 },
        { opacity: 1, x: 0, duration: 1, ease: "power2.out", delay: index * 0.2, scrollTrigger: { trigger: reason, start: "top 85%" } }
      );
    });
  }, []);

  return (
    <section className="why-choose-us">
      <div className="container"  ref={sectionRef}>
        <h2>Why Choose Us?</h2>
        <div className="content">
          <div className="image">
            <img src={image} alt="Why Choose Us" />
          </div>
          <div className="reasons">
            {[
              "Expert Team with Years of Experience",
              "Student Satisfaction is Our Priority",
              
              "Proven Track Record of Success",
            ].map((text, index) => (
              <div className="reason" key={index} ref={(el) => (reasonsRef.current[index] = el)}>
                <FaCheckCircle className="icon" />
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
